"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToHilPackageFunction = mapToHilPackageFunction;
exports.mapFromHilPackageFunction = mapFromHilPackageFunction;
const package_function_signal_mapper_js_1 = require("./package-function-signal.mapper.js");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
function mapToHilPackageFunction(componentFunction) {
    return {
        id: componentFunction.id ?? (0, cadstrom_shared_1.generateReadableId)(cadstrom_shared_1.CadstromObjectType.PackageFunction, componentFunction.name),
        functionClass: componentFunction.functionClass ?? null,
        name: componentFunction.name,
        busRole: componentFunction.busRole ?? null,
        mustBeAssigned: componentFunction.mustBeAssigned ?? null,
        classParameters: componentFunction.classParameters ?? null,
        conditions: componentFunction.conditions ?? null,
        resourceConsumed: componentFunction.resourceConsumed ?? null,
        boundaries: componentFunction.boundaries ?? null,
        functionSignals: Object.fromEntries(componentFunction.functionSignals.map((fs) => [fs.name, (0, package_function_signal_mapper_js_1.mapToHilPackageFunctionSignal)(fs)])),
    };
}
function mapFromHilPackageFunction(hilPackageFunction) {
    return {
        id: hilPackageFunction.id,
        name: hilPackageFunction.name,
        functionClass: hilPackageFunction.functionClass ?? undefined,
        busRole: hilPackageFunction.busRole ?? undefined,
        mustBeAssigned: hilPackageFunction.mustBeAssigned ?? undefined,
        classParameters: hilPackageFunction.classParameters ?? undefined,
        conditions: hilPackageFunction.conditions ?? undefined,
        resourceConsumed: hilPackageFunction.resourceConsumed ?? undefined,
        boundaries: hilPackageFunction.boundaries ?? undefined,
        functionSignals: Object.entries(hilPackageFunction.functionSignals).map(([functionClassSignalName, fs]) => (0, package_function_signal_mapper_js_1.mapFromHilPackageFunctionSignal)(functionClassSignalName, fs)),
    };
}
//# sourceMappingURL=package-function.mapper.js.map